import EditIcon from "@mui/icons-material/Edit";
import parse from "html-react-parser";
import { Accordion, Container, Row, Col, Button } from "react-bootstrap";

import HTMLEditor from "components/UI/HTMLEditor";

const Justification = ({
  review,
  userCanEdit,
  setIsEditing,
  isEditing,
  handleChange,
  handleChangeTextField,
  textFieldUpdate,
}) => {
  return (
    <Accordion className="mb-4 border-0" defaultActiveKey="0" flush>
      <Accordion.Item eventKey="0">
        <Accordion.Header>
          <h6 className="fw-bold text-dark">JUSTIFICATION</h6>
        </Accordion.Header>
        <Accordion.Body>
          <Container>
            <Row>
              {isEditing === "just" ? (
                <Col>
                  <HTMLEditor
                    name="just"
                    handleChange={handleChangeTextField}
                    setIsValid={() => {}}
                    isValid={true}
                    defaultValue={review?.just}
                  />
                </Col>
              ) : (
                <Col>{review?.just && parse(review?.just)}</Col>
              )}
              <Col sm={1}>
                {userCanEdit &&
                  (isEditing === "just" ? (
                    <>
                      <Button
                        variant="primary"
                        onClick={() =>
                          handleChange({
                            target: {
                              name: "just",
                              value: textFieldUpdate.just,
                            },
                          })
                        }
                      >
                        Save
                      </Button>
                      <Button
                        variant="warning"
                        className="mt-2"
                        onClick={() => setIsEditing("")}
                      >
                        Cancel
                      </Button>
                    </>
                  ) : (
                    <div className="d-flex justify-content-end">
                      <EditIcon
                        className="edit-button clickable"
                        onClick={() => {
                          setIsEditing("just");
                        }}
                        data-testid="edit-just"
                      />
                    </div>
                  ))}
              </Col>
            </Row>
          </Container>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default Justification;
